import React from 'react';
import { useController } from 'react-hook-form';
import CheckBox from './CheckBox';
type CheckBoxType = React.ComponentProps<typeof CheckBox>;
type ControlledCheckBoxProps = CheckBoxType & {
  name: string;
  checked: boolean;
  middleware?: (value: boolean) => void;
};
const ControlledCheckBox: React.FC<ControlledCheckBoxProps> = props => {
  const { name, checked, middleware, ...rest } = props;
  const onChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    if (middleware) {
      middleware(checked);
    }
    field.onChange(checked);
  };
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    defaultValue: checked,
  });
  return (
    <CheckBox
      {...rest}
      {...field}
      checked={field.value}
      errorMsg={error?.message}
      onChange={onChange}
    />
  );
};
export default ControlledCheckBox;